// extracted by mini-css-extract-plugin
export default {"message_button":"mymessage_message_button__q0t18"};